module.exports = __webpack_public_path__ + "img/vehicles.6983f093.svg";